/*eslint-disable*/ export const messages = JSON.parse(
    '{"ads.title.mlt":"Samankaltaisia ilmoituksia","ads.title.personal":"Suosituksia sinulle","ads.title.popular":"Suosittuja ilmoituksia"}',
);
